var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class OverallSimilar {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get comparer() {
        return this.parent;
    }
    get parse() {
        return this.comparer.parseExpect;
    }
    get reachedSimilarityArray() {
        if (this.comparer.compareEqual.isEqual)
            return [100];
        if (this.parse.isRegex) {
            if (this.comparer.compareRegex.matchesRegex) {
                return [100];
            }
            return [0];
        }
        if (this.parse.isCleanedExpectedStringANumber) {
            if (this.comparer.compareNumber.matchesNumberValue)
                return [100];
            // return 0;
        }
        const { similarityByLevenshtein } = this.comparer.compareLevenshtein;
        const { similarityBySimilarText } = this.comparer.compareSimilarText;
        const { similarityByStartsWith } = this.comparer.compareStartsWith;
        return [similarityByLevenshtein, similarityBySimilarText, similarityByStartsWith];
    }
    get reachedSimilarity() {
        const highest = Math.max(...this.reachedSimilarityArray);
        return highest;
    }
    /*
    Levenstein and similar_text have same success percentrage (insert, replace, ...) for search "1" in "102" and "201"
    Therefore include startsWithSimilarity in display UI order
     */
    get averageAlgorithmSimilarity() {
        const average = this.reachedSimilarityArray.reduce((p, c) => p + c, 0) / this.reachedSimilarityArray.length;
        return average;
    }
}
__decorate([
    computed.struct
], OverallSimilar.prototype, "reachedSimilarityArray", null);
